import { useEffect, useRef, useState } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";

const L1Profile = (props: any) => {
	const COLORS: any = {
		"DATA COMMUNICATION": "#3B60A0",
		ELECTRICAL: "#86BC25",
		MRO: "#334422",
		LIGHTING: "#0097A9",
		"Not Selected": "#5EC1C8",
	};
	const RADIAN = Math.PI / 180;

	const renderCustomizedLabel = ({
		cx,
		cy,
		midAngle,
		innerRadius,
		outerRadius,
		percent,
		index,
	}: any) => {
		const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
		const x = cx + radius * Math.cos(-midAngle * RADIAN);
		const y = cy + radius * Math.sin(-midAngle * RADIAN);

		return percent * 100 > 1 ? (
			<text
				x={x}
				y={y}
				fill="white"
				textAnchor="middle"
				dominantBaseline="central"
			>
				{`${(percent * 100).toFixed(0)}%`}
			</text>
		) : (
			<></>
		);
	};

	const updateLegend = (value: any) => {
		return value?.replace("Communication", "Comm.");
	};

	const updateFill = (category: any) => {
		if (props.selection.L1) {
			if (props.selection.L1.includes(category)) {
				// green
				return /* "#046a38" */ COLORS[category];
			} else {
				// gray
				return "#53565a";
			}
		} else {
			return COLORS[category] ? COLORS[category] : COLORS["Not Selected"];
		}
	};

	const handleL1Selection = (data: any) => {
		props.handleClick(data.category);
	};

	return (
		<div className="h-full w-full flex flex-col">
			<div className="headSpace">
				<div className="headContent">L1 Spend Profile</div>
			</div>
			<div className="grow w-full h-[60%]">
				<ResponsiveContainer width="100%" height="100%">
					<PieChart>
						<Pie
							data={props.data}
							cx="50%"
							cy="50%"
							innerRadius="40%"
							outerRadius="80%"
							fill="#8884d8"
							paddingAngle={0}
							dataKey="cost"
							label={renderCustomizedLabel}
							labelLine={false}
							nameKey="category"
						>
							{props.data &&
								props.data.map((d: any, index: any) => (
									<Cell
										key={`cell-${index}`}
										fill={updateFill(d.category)}
										onClick={() => handleL1Selection(d)}
									/>
								))}
						</Pie>
					</PieChart>
				</ResponsiveContainer>
			</div>
			<div className="contentFooter h-[12vh]">
				<div className="flex flex-wrap items-start gap-x-2 gap-y-2 p-4 w-full">
					{props.data &&
						props.data.map((entry: any, index: any) => (
							<div
								key={`legend-${index}`}
								className="flex items-center min-h-[20px] cursor-pointer"
								onClick={() => handleL1Selection(entry)}
							>
								<div
									className="w-3 h-3 mr-2"
									style={{
										backgroundColor: updateFill(
											entry.category
										),
									}}
								></div>
								<span
									className="text-[0.85em] leading-tight"
									style={{
										color: updateFill(entry.category),
									}}
								>
									{updateLegend(entry.category)}
								</span>
							</div>
						))}
				</div>
			</div>
		</div>
	);
};

export default L1Profile;
